<template>
    <div class="product-favorites-btn">
        <transition name="fade" appear>
            <button
                :class="classNames"
                type="button"
                :disabled="isLoading"
                @click.prevent="clickHandler"
            >
                <template v-if="!isLoading">
                    <slot>
                        <svg width="24" height="24">
                            <use xlink:href="/sprite.svg#icon-favorite-heart"></use>
                        </svg>
                        <span v-if="pageEquipment" class="favorite-text">{{ isAddedText }}</span>
                    </slot>
                </template>

                <span v-else class="spinner-border spinner-border-sm color-white" />
            </button>
        </transition>
    </div>
</template>

<script>

import { globalErrorHandler } from '../../services/error-handling';

const ALL_FAVS = window.specialtyApp.initialFavoriteState;

export default {
    name: 'favorites-btn',

    inject: ['$favoritesService'],

    props: {
        id: {
            required: true,
        },

        className: {
            type: String,
            default: 'favorite-heart',
        },

        pageEquipment: {
            type: Boolean,
        },
    },

    data() {
        return {
            isLoading: false,
            isAdded: false,
            isAddedText: 'Добавить в избранное',
        };
    },

    methods: {
        async addToFavorites() {
            this.isLoading = true;

            try {
                await this.$favoritesService.addToFavorites(this.id);
                this.isAdded = true;
                this.isAddedText = 'В избранном';
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },

        async removeFromFavorites() {
            this.isLoading = true;

            try {
                await this.$favoritesService.removeFromFavorites(this.id);

                // Перезагрузка страницы при удалении товара из избранного в ЛК
                if (window.location.href.indexOf('/personal/favorite/') > -1) {
                    window.location.href = '/personal/favorite/';
                }

                this.isAdded = false;
                this.isAddedText = 'Добавить в избранное';
            } catch (e) {
                globalErrorHandler(e);
            } finally {
                this.isLoading = false;
            }
        },

        async checkFavStatus() {
            if (!ALL_FAVS) return;

            if (ALL_FAVS.find((item) => +item.PRODUCT_ID === +this.id)) {
                this.isAdded = true;
                this.isAddedText = 'В избранном';
            }
        },

        clickHandler() {
            if (!this.isAdded) {
                this.addToFavorites();
                return;
            }

            this.removeFromFavorites();
        },
    },

    computed: {
        classNames() {
            return {
                [this.className]: true,
                [`${this.className}--active`]: this.isAdded,
            };
        },
    },

    created() {
        this.checkFavStatus();
    },
};
</script>
